import React, { useState } from "react";
import { Form, Image, Alert } from "react-bootstrap";

function CustomUploader({ label, placeholder, setCustomLogo, background }) {
  const [preview, setPreview] = useState(null); // To hold the preview URL
  const [error, setError] = useState(""); // To hold error messages

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      // Check file size (50KB = 50 * 1024 bytes)
      if (file.size > 50 * 1024) {
        setError("File size cannot exceed 50KB");
        setCustomLogo(null);
        setPreview(null);
      } else {
        setError(""); // Clear any previous error
        setCustomLogo(file);
        setPreview(URL.createObjectURL(file)); // Generate a preview URL
      }
    }
  };

  return (
    <Form.Group controlId="formFile" className="mb-3">
      <Form.Label className="fw-bold">{label}</Form.Label>
      {(preview || (placeholder && placeholder.length > 0)) && (
        <div className="my-2">
          <div
            className="launcher"
            style={{ background: background ? background : "white" }}
          >
            <Image
              className="mw-100"
              src={preview ? preview : placeholder}
              alt="Custom Logo Preview"
            />
          </div>
        </div>
      )}
      <Form.Control
        type="file"
        accept="image/*" // Accept only image files
        onChange={handleFileChange}
      />
      {error && (
        <Alert variant="danger" className="mt-2">
          {error}
        </Alert>
      )}
    </Form.Group>
  );
}

export default CustomUploader;
